import axiosInstance from "../../utils/config/config";

export const getSubscriptionOfUser = async (userId) => {
  try {
    const response = await axiosInstance.get(
      `/subscription/getSubscriptions?creatorId=${userId}`
    );

    return response.data.subscriptions;
  } catch (error) {
    console.error("Failed to create user", error);
    return null;
  }
};
